import React, { useState } from 'react';
import AboutSider from './sider/AboutSider';
import * as S from './AboutLayout.styles';
import { Outlet, useLocation } from 'react-router-dom';
import { useResponsive } from '../../../hooks/useResponsive';
import DefaultNavbar from '../HomeLayout/examples/Navbars/DefaultNavbar';
import routes from '../HomeLayout/routes';
import { Layout, Row, Col, Drawer } from 'antd';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';

const { Content } = Layout;

// Navbar height constant
const NAVBAR_HEIGHT = 72;

const AboutLayout: React.FC = (props: any) => {
  const [siderOpen, setSiderOpen] = useState(false);
  const { isDesktop } = useResponsive();
  const date = new Date().getFullYear();

  const toggleSider = () => setSiderOpen(!siderOpen);
  const closeSider = () => setSiderOpen(false);

  // Desktop layout with sidebar
  const desktopLayout = (
    <S.PageWrapper>
      <S.DesktopContainer>
        {/* Sidebar */}
        <S.SidebarColumn>
          <AboutSider />
        </S.SidebarColumn>
        
        {/* Main Content */}
        <S.ContentColumn>
          <S.ContentCard>
            <Outlet />
          </S.ContentCard>
          <S.FooterText>
            © 2022-{date} Smallize Pty Ltd. All rights reserved.
          </S.FooterText>
        </S.ContentColumn>
      </S.DesktopContainer>
    </S.PageWrapper>
  );

  // Mobile/Tablet layout with drawer
  const mobileLayout = (
    <S.PageWrapper>
      {/* Mobile menu button */}
      <S.MobileMenuButton onClick={toggleSider}>
        <MenuOutlined style={{ fontSize: '20px' }} />
        <span>Menu</span>
      </S.MobileMenuButton>

      {/* Mobile drawer */}
      <Drawer
        title={
          <S.DrawerTitle>
            Navigation
          </S.DrawerTitle>
        }
        placement="left"
        onClose={closeSider}
        open={siderOpen}
        width={280}
        bodyStyle={{ padding: 0 }}
        closeIcon={<CloseOutlined />}
      >
        <S.MobileSiderWrapper onClick={closeSider}>
          <AboutSider />
        </S.MobileSiderWrapper>
      </Drawer>

      {/* Mobile content */}
      <S.MobileContainer>
        <S.MobileContentCard>
          <Outlet />
        </S.MobileContentCard>
        <S.FooterText>
          © 2022-{date} Smallize Pty Ltd. All rights reserved.
        </S.FooterText>
      </S.MobileContainer>
    </S.PageWrapper>
  );

  return (
    <>
      <DefaultNavbar routes={routes} />
      {isDesktop ? desktopLayout : mobileLayout}
    </>
  );
};

export default AboutLayout;